module.exports = __webpack_public_path__ + "static/media/13.5f314a4e.png";